export default __webpack_public_path__ + "static/media/Food1.6415c782.jpg";